import styles from './assets/style.scss';
import { ILabelProps } from './entities';

import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const BCLabel = (props: ILabelProps) => {
	const { ellipsis, align, customStyles, children, title } = props;

	const classNames = cx({
		label: true,
		ellipsis,
		left: align === 'left',
		center: align === 'center',
		right: align === 'right'
	});

	return (
		<span
			onClick={props.onClick}
			className={[classNames, 'label', props.className].join(' ')}
			style={customStyles}
			title={title}
		>
			{children}
		</span>
	);
};
export default BCLabel;
export { ILabelProps };
